var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('login-view',{attrs:{"active":_vm.active,"installed":_vm.installed,"modal":_vm.modal,"dev":_vm.dev}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }